import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSword: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sword, action, gaming"} maskId="square-filled-radius-0-stroke-1-IconSword"><path d="M6 9L3.5 12L5.5 15.5L2 19L5 22L8.5 18.5L12 20.5L15 18L6 9Z" fill="currentColor"/><path d="M13.7307 3L8.33594 10.0438L13.9555 15.6633L20.9993 10.2686V3H13.7307Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSword;
